/**
 * Created by USER on 18/8/22.
 */
import React, { Component } from 'react';

export default class Sorry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorTxt: '',
      time: 3
    };
  }
  componentDidMount() {
    const b64DecodeUnicode = function (str) {
      return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    };
    const error = window.location.hash.substr(1);
    if (error) {
      try {
        const errorTxt = b64DecodeUnicode(error);
        this.setState({
          errorTxt
        });
      } catch (err) {}
    }

    let time = 3;
    const countdown = setInterval(() => {
      this.setState({
        time
      });
      if (time === 0) {
        window.open(' ', '_self').close();
        clearInterval(countdown);
      }
      time--;
    }, 1000);
  }

  render() {
    const {errorTxt, time} = this.state;
    return (
      <div className="sorry_container">
        <div className="sorry_success_img">
          <img src="https://lubansohz.oss-cn-hangzhou.aliyuncs.com/lubanso-web/images/2018-08-22/9d48df5741be4037811dd2ac46ec87d2.png" alt="LUBANSO" />
          <div className="sorry_success">支付失败</div>
          <div className="sorry_notice">{errorTxt}</div>
          <div className="sorry_notice_two">抱歉，支付似乎出了一点问题，您可以稍后重试，或者联系我们的工作人员</div>
          <div>页面将于&nbsp;<span className="sorry_account">{time}</span>&nbsp;秒后关闭</div>
        </div>
      </div>
    );
  }
}
